import coerce_1 from './node_modules/semver/functions/coerce.js';
import gte_1 from './node_modules/semver/functions/gte.js';
import { APP_NAME, APP_FEATURE_MIN_SUPPORT_VERSION } from './constants.js';
import { cookieService } from './cookieService.js';

function matchAgent(regExp) {
    return new RegExp(regExp).exec(window.navigator.userAgent);
}
function systemFontScale() {
    if (typeof window === 'undefined') {
        return 1;
    }
    const scale = matchAgent(/fontScale\/([\S]*)/i);
    if (!scale || !scale[1]) {
        return 1;
    }
    return Number(scale[1]);
}
function isIos() {
    return ([
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(window.navigator.platform) ||
        // iPad on iOS 13 detection
        (window.navigator.userAgent.includes('Mac') && 'ontouchend' in document));
}
function isAndroid() {
    return Boolean(matchAgent(/android/i));
}
function isAppSupportedOS() {
    return isIos() || isAndroid();
}
function isAndroidAppWebView() {
    return Boolean(matchAgent(APP_NAME.android));
}
function isIosAppWebView() {
    return Boolean(matchAgent(APP_NAME.ios));
}
function isAppWebView() {
    return isAndroidAppWebView() || isIosAppWebView();
}
function isKakaoBrowser() {
    return Boolean(matchAgent(/KAKAOTALK/));
}
function isPosWebview() {
    return cookieService.isPosPlatform();
}
function platform() {
    if (isAndroidAppWebView()) {
        return 'android';
    }
    if (isIosAppWebView()) {
        return 'ios';
    }
    if (isPosWebview()) {
        return 'windows pos';
    }
    return 'web';
}
function appVersion() {
    const currentPlatform = platform();
    if (currentPlatform === 'web' || currentPlatform === 'windows pos') {
        return null;
    }
    const matched = matchAgent(new RegExp(`${APP_NAME[currentPlatform]}/([\\.\\d]+)`));
    if (!matched) {
        return null;
    }
    return matched[1];
}
function isEnoughForTargetAppVersion(targetVersion, checkVersion = appVersion()) {
    if (!checkVersion) {
        return false;
    }
    if (targetVersion === 'dev') {
        return checkVersion.includes('/dev');
    }
    const coerced = coerce_1(checkVersion);
    if (!coerced) {
        return false;
    }
    return gte_1(coerced, targetVersion);
}
function hasAppFeature(featureKey) {
    const currentPlatform = platform();
    if (currentPlatform === 'web' || currentPlatform === 'windows pos') {
        return false;
    }
    const features = APP_FEATURE_MIN_SUPPORT_VERSION[currentPlatform];
    const targetVersion = features[featureKey];
    if (!targetVersion) {
        return false;
    }
    return isEnoughForTargetAppVersion(targetVersion);
}

export { appVersion, hasAppFeature, isAndroid, isAndroidAppWebView, isAppSupportedOS, isAppWebView, isEnoughForTargetAppVersion, isIos, isIosAppWebView, isKakaoBrowser, isPosWebview, platform, systemFontScale };
//# sourceMappingURL=userAgent.js.map
